import { EBEPaymentMethodsName, EPaymentProvider, PaymentMethod, PublicConfig } from '../contracts';

export function resolveNuveiSafeChargeConfig(
  paymentMethods: PaymentMethod[] | undefined,
  fallback: PublicConfig | undefined,
): PublicConfig | undefined {
  const cardMethod = paymentMethods?.find(
    (paymentMethod) =>
      paymentMethod.provider === EPaymentProvider.nuvei &&
      paymentMethod.paymentMethodName === EBEPaymentMethodsName.card,
  );
  const methodConfig =
    cardMethod?.publicConfig && 'merchantSiteId' in cardMethod.publicConfig
      ? cardMethod.publicConfig
      : undefined;

  if (!methodConfig && !fallback) {
    return undefined;
  }

  return {
    env: methodConfig?.env || fallback?.env,
    merchantId: methodConfig?.merchantId || fallback?.merchantId,
    merchantSiteId: methodConfig?.merchantSiteId || fallback?.merchantSiteId,
  } as PublicConfig;
}
